import { colorsPalettes } from "@similarweb/styles";

export const VERTICAL_SCROLLBAR_STYLE = {
    backgroundColor: colorsPalettes.carbon["100"],
    borderRadius: 5,
    width: 7,
};

export const VERTICAL_SCROLLBAR_CONTAINER_STYLE = {
    background: "transparent",
    right: 1,
};

export const SCROLL_AREA_STYLE = {
    maxHeight: 320,
};
